import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-018-chart",
  "use": "icon-018-chart-usage",
  "viewBox": "0 0 385.51 385.51",
  "content": "<symbol viewBox=\"0 0 385.51 385.51\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-018-chart\"><g><g><path d=\"m239.243 97.596h-92.976l-30.756 58.617h154.488z\" fill=\"#e56353\" /><path d=\"m0 376.578h385.51l-35.78-68.262h-313.95z\" fill=\"#44c4a1\" /><path d=\"m192.755 8.932-40.399 77.042h80.796z\" fill=\"#fcd462\" /><path d=\"m276.088 167.835h-166.668l-30.704 58.619h228.078z\" fill=\"#27a2db\" /><path d=\"m312.884 238.076h-240.258l-30.755 58.618h301.768z\" fill=\"#e1e6e9\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/018-chart.svg
// module id = /6gR
// module chunks = 102